// include all desired resources as dependencies here
define('vspot-resources',['angular', 'angular-resource',
    'vspot-angular/resources/user-resource',
    'vspot-angular/resources/form-entries-resource',
    'vspot-angular/resources/group-resource',
    'vspot-angular/resources/org-group-resource',
    'vspot-angular/resources/school-resource',
    'vspot-angular/resources/org-activity-resource',
    'vspot-angular/resources/org-dashboard-pins-resource',
    'vspot-angular/resources/org-comment-resource',
    'vspot-angular/resources/org-jobs-resource',
    'vspot-angular/resources/org-job-titles-resource',
    'vspot-angular/resources/job-assignment-resource',
    'vspot-angular/resources/org-job-assignment-resource',
    'vspot-angular/resources/job-resource',
    'vspot-angular/resources/org-invitation-resource',
    'vspot-angular/resources/org-volunteer-resource',
    'vspot-angular/resources/org-signup-resource',
    'vspot-angular/resources/pledge-resource',
    'vspot-angular/resources/activity-type-resource',
    'vspot-angular/resources/activity-themes-resource',
    'vspot-angular/resources/categories-resource',
    'vspot-angular/resources/activity-badges-resource',
    'vspot-angular/resources/activity-tags-resource',
    'vspot-angular/resources/org-event-resource',
    'vspot-angular/resources/utilities-resource',
    'vspot-angular/resources/message-resource',
    'vspot-angular/resources/organizer-resource',
    'vspot-angular/resources/wepay-resource',
    'vspot-angular/resources/paypal-resource',
    'vspot-angular/resources/comment-resource',
    'vspot-angular/resources/cookie-resource',
    'vspot-angular/resources/coreg-resource',
    'vspot-angular/resources/invitation-resource',
    'vspot-angular/resources/organization-resource',
    'vspot-angular/resources/group-activity-resource',
    'vspot-angular/resources/org-group-activity-resource',
    'vspot-angular/resources/activity-resource',
    'vspot-angular/resources/activity-limits-resource',
    'vspot-angular/resources/org-reports-resource',
    'vspot-angular/resources/org-lists-resource',
    'vspot-angular/resources/admin-resource',
    'vspot-angular/resources/login-resource',
    'vspot-angular/resources/calendar-resource',
    'vspot-angular/resources/nlytcs-resource',
    'vspot-angular/resources/charges-resource',
    'vspot-angular/resources/event-resource',
    'vspot-angular/resources/org-teachers-resource',
    'vspot-angular/resources/volunteer-resource',
    'vspot-angular/resources/page-categories-resource',
    'vspot-angular/resources/assigners-resource',
    'vspot-angular/resources/waitlist-resource',
    'vspot-angular/resources/browser-info-resource'
    ],
    function (
        angular,
        ar,
        User,
        FormEntries,
        Group,
        OrgGroup,
        School,
        OrgActivity,
        OrgDashboardPins,
        OrgComment,
        OrgJobs,
        OrgJobTitles,
        JobAssignment,
        OrgJobAssignment,
        Job,
        OrgInvitation,
        OrgVolunteer,
        OrgSignup,
        Pledge,
        ActivityType,
        ActivityThemes,
        Categories,
        ActivityBadges,
        ActivityTags,
        OrgEvent,
        Utilities,
        Message,
        Organizer,
        WePay, // Used to be OrgWePay
        PayPal, // Used to be OrgWePay
        Comment,
        Cookie,
        Coreg,
        Invitation,
        Organization,
        GroupActivity,
        OrgGroupActivity,
        Activity,
        ActivityLimit,
        OrgReports,
        OrgLists,
        Admin,
        Login,
        Calendar,
        Nlytcs,
        Charges,
        EventRea,
        OrgTeachers,
        Volunteer,
        PageCategories,
        Assigners,
        Waitlist,
        BrowserInfo
    ) {

    'use strict';

    /*
     *  Resources
     *
     *  Resources are declared all in one file to simplify including resources across the app.
     *  They are defined in their own respective files.
     *
     *  Resources are meant to provide a layer of abstraction above $http. It should be
     *  the only thing to directly interact with the server. By having all actions with the
     *  server defined in one place, it makes all actions reusable throughout the application,
     *  and when issues with server communication arise, there is one place to look.
     *
     *  The other thing that's valuable about resources is that they do not require callbacks
     *  in order for them to function. Each call to a resource should return an empty Resource
     *  instance, which will dynamically fill with requested data as soon as the server returns
     *  a value. To take advantage of this, the resource object can be assigned to a variable in
     *  scope, and you may use any of the expected attributes from your request in your view.
     *  Then, once the resource gets a response from the server, the attributes will be populated,
     *  the scope variables will be refreshed, and the view should respond to the now filled in values.
     *
     *  If you wish to hide your elements until the resource is loaded, you can use
     *  ng-show="resourceVarName.resolved"
     *
     *  If any logic besides a request to the server is required, please create an associated
     *  service, and refer to the vspot-angular/services documentation.
     *
     *  By default, resources will generally have the following methods available to them:
     *
     *  { 'get':    {method:'GET'}, // get one
     *    'save':   {method:'POST'},
     *    'query':  {method:'GET', isArray:true}, // get all
     *    'remove': {method:'DELETE'},
     *    'delete': {method:'DELETE'} };
     *
     *  Typically, return values will include status, whether or not the call succeeded,
     *  and code, the i18n error code generated, if any.
     */

    // list all available resources here
    var resources = {
        'resources.User':               User,
        'resources.FormEntries':        FormEntries,
        'resources.Group':              Group,
        'resources.OrgGroup':           OrgGroup,
        'resources.School':             School,
        'resources.OrgActivity':        OrgActivity,
        'resources.OrgDashboardPins':   OrgDashboardPins,
        'resources.OrgComment':         OrgComment,
        'resources.OrgJobs':            OrgJobs,
        'resources.OrgJobTitles':       OrgJobTitles,
        'resources.JobAssignmet':       JobAssignment,
        'resources.OrgJobAssignment':   OrgJobAssignment,
        'resources.Job':                Job,
        'resources.OrgInvitation':      OrgInvitation,
        'resources.OrgVolunteer':       OrgVolunteer,
        'resources.OrgSignup':          OrgSignup,
        'resources.Pledge':             Pledge,
        'resources.ActivityType':       ActivityType,
        'resources.ActivityThemes':     ActivityThemes,
        'resources.Categories':         Categories,
        'resources.ActivityBadges':     ActivityBadges,
        'resources.ActivityTags':       ActivityTags,
        'resources.OrgEvent':           OrgEvent,
        'resources.Utilities':          Utilities,
        'resources.Message':            Message,
        'resources.Organizer':          Organizer,
        'resources.WePay':              WePay, // Used to be OrgWePay
        'resources.PayPal':             PayPal, // Used to be OrgWePay
        'resources.Comment':            Comment,
        'resources.Cookie':             Cookie,
        'resources.Coreg':              Coreg,
        'resources.Invitation':         Invitation,
        'resources.Organization':       Organization,
        'resources.GroupActivity':      GroupActivity,
        'resources.OrgGroupActivity':   OrgGroupActivity,
        'resources.Activity':           Activity,
        'resources.ActivityLimit':      ActivityLimit,
        'resources.OrgReports':         OrgReports,
        'resources.OrgLists':           OrgLists,
        'resources.Admin':              Admin,
        'resources.Login':              Login,
        'resources.Calendar':           Calendar,
        'resources.Nlytcs':             Nlytcs,
        'resources.Charges':            Charges,
        'resources.EventRea':           EventRea,
        'resources.OrgTeachers':        OrgTeachers,
        'resources.Volunteer':          Volunteer,
        'resources.PageCategories':     PageCategories,
        'resources.Assigners':          Assigners,
        'resources.Waitlist':           Waitlist,
        'resources.BrowserInfo':        BrowserInfo
    };

    var resourceModule = angular.module('vspot.resources', ['ngResource']);

    for (var resource in resources) {
        resourceModule.factory(resource, resources[resource]);
    }
});
